// extracted by mini-css-extract-plugin
module.exports = {"filterItemContainer":"SearchDropdown_filterItemContainer__3kvZM","filterType":"SearchDropdown_filterType__1dmLc","closeIcon":"SearchDropdown_closeIcon__3Ejnt"};